import React, { useMemo, useState } from "react";
import { Table } from "react-bootstrap";
import styled from "styled-components";
import { IngresoPorPropietario } from "../../../services/analisisFinanzas";
import { useEstadisticasNumericas } from "../../../hooks/estadisticasNumericas";
import { currencyFormat } from "../../../utils/numberUtils";
import EstadisticasBadges from "../../organisms/EstadisticasBadges";
import Pagination from "../../organisms/Pagination";
import { generatePage } from "../../../utils/tableUtils";

interface IngresosPorPropietarioTableProps {
  ingresosPorPropietario: IngresoPorPropietario[];
  isLoading: boolean;
  itemsPorPagina: number;
}

function IngresosPorPropietarioTable({
  ingresosPorPropietario,
  isLoading,
  itemsPorPagina,
}: IngresosPorPropietarioTableProps) {
  const [activePageNumber, setActivePageNumber] = useState(1);
  const estadisticas = useEstadisticasNumericas(
    ingresosPorPropietario,
    (item) => item.ingresos
  );

  const paginaActual = useMemo(
    () =>
      generatePage(
        ingresosPorPropietario,
        activePageNumber,
        itemsPorPagina
      ) as IngresoPorPropietario[],
    [ingresosPorPropietario, activePageNumber, itemsPorPagina]
  );

  return (
    <>
      <EstadisticasBadges
        estadisticas={estadisticas}
        formatearValor={currencyFormat}
      />

      <Table responsive hover>
        <thead>
          <tr>
            <StyledColHeader>Propietario</StyledColHeader>
            <StyledColHeader>Ingresos</StyledColHeader>
          </tr>
        </thead>
        <tbody>
          {paginaActual.map((item) => (
            <tr key={item.idPropietario}>
              <td>{item.propietario}</td>
              <td>{currencyFormat(item.ingresos)}</td>
            </tr>
          ))}
          {estadisticas && (
            <StyledSummaryRow>
              <td>Total</td>
              <td>{currencyFormat(estadisticas.total)}</td>
            </StyledSummaryRow>
          )}
          {!isLoading && paginaActual.length === 0 && (
            <tr>
              <td colSpan={2}>
                No hay ingresos por propietario para el rango de fechas seleccionado.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <Pagination
        pageSize={itemsPorPagina}
        setActivePageNumber={setActivePageNumber}
        activePageNumber={activePageNumber}
        rows={ingresosPorPropietario}
      />
    </>
  );
}

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledSummaryRow = styled("tr")`
  background-color: ${(props) => props.theme.colors.light};
  font-weight: 700;
`;

export default IngresosPorPropietarioTable;
